import React, { useState, useEffect } from "react";
import "./chatwidget.css";

const Chatwidget = () => {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    // Auto-open popup after 2 seconds
    const timer = setTimeout(() => setIsOpen(true), 2000);
    return () => clearTimeout(timer);
  }, []);

  const phoneNumber = "9867378209"; // Replace with your number
  const message = "Hi! I want to order groceries today.";
  const encodedMessage = encodeURIComponent(message);
  const whatsappLink = `https://wa.me/${phoneNumber}?text=${encodedMessage}`;

  return (
    <div className="whatsapp-widget">
      {/* Floating Bubble */}
      {!isOpen && (
        <div
          className="whatsapp-bubble"
          onClick={() => setIsOpen(true)}
          aria-label="Chat with us on WhatsApp"
        >
          <img
            src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg"
            alt="WhatsApp"
          />
        </div>
      )}

      {/* Chat Box */}
      {isOpen && (
        <div className="whatsapp-chat">
          <div className="chat-header">
            <span>Grocery Assistant</span>
            <button
              className="close-btn"
              onClick={() => setIsOpen(false)}
              aria-label="Close chat"
            >
              ✕
            </button>
          </div>
          <div className="chat-body">
            <p>Hi there! 👋 Looking for groceries? We can help you today.</p>
          </div>
          <button
            className="chat-button"
            onClick={() => window.open(whatsappLink, "_blank")}
          >
            Start WhatsApp Chat
          </button>
        </div>
      )}
    </div>
  );
};

export default Chatwidget;
